import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Specials } from "./components/Specials";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { MenuSection } from "./components/MenuSection";
import { SignatureHighlight } from "./components/SignatureHighlight";
import { Gallery } from "./components/Gallery";
import { Testimonials } from "./components/Testimonials";
import { Newsletter } from "./components/Newsletter";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

const HomePage = () => (
  <div className="min-h-screen bg-brand-cream text-brand-charcoal">
    <Header />
    <main>
      <Hero />
      <About />
      <Specials />
      <WhyChooseUs />
      <MenuSection />
      <SignatureHighlight />
      <Gallery />
      <Testimonials />
      <Newsletter />
      <Contact />
    </main>
    <Footer />
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          background: "#1A1A1A",
          color: "#F8F1E7",
          border: "1px solid #B3001B",
          fontFamily: "DM Sans, sans-serif",
        },
      }}
    />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
